import { render, staticRenderFns } from "./bioLook_updata.vue?vue&type=template&id=baee595a&"
import script from "./bioLook_updata.vue?vue&type=script&lang=js&"
export * from "./bioLook_updata.vue?vue&type=script&lang=js&"
import style0 from "./bioLook_updata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports